import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 md:py-32 bg-[#F8FAFC]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-sm text-[#1656b8] uppercase tracking-[0.2em] font-semibold">
            What We Do
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight mt-3">
            Premium construction & landscaping services
          </h2>
          <p className="mt-4 text-slate-600">
            From the first design sketch to the final finish, we handle every part of
            your outdoor and building project.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((service, i) => {
            const Icon = service.icon;
            return (
              <motion.button
                key={i}
                data-testid={`service-card-${i}`}
                onClick={() => scrollTo("contact")}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="text-left bg-white border border-slate-200 p-8 rounded-xl hover:shadow-xl hover:border-[#1656b8]/30 transition-all duration-300 group flex flex-col items-start gap-4 hover:-translate-y-1 relative overflow-hidden"
              >
                <span className="w-14 h-14 rounded-xl bg-[#E8F0FE] flex items-center justify-center group-hover:bg-[#1656b8] transition-colors duration-300">
                  <Icon size={26} className="text-[#1656b8] group-hover:text-white transition-colors duration-300" />
                </span>
                <h3 className="font-heading text-xl font-semibold text-slate-900">
                  {service.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {service.description}
                </p>
                <span className="flex items-center gap-1 text-[#1656b8] text-sm font-semibold mt-auto pt-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  Request a quote <ArrowUpRight size={16} />
                </span>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
